import { DashedLineBackground } from "@components/PerformanceChart/DashedLineBackground";
import { usePerformanceChart } from "@hooks";
import { PropsWithChildren } from "react";

export const Canvas = ({ children }: PropsWithChildren) => {
  const { width, height } = usePerformanceChart();

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none">
      <DashedLineBackground />

      {children}
    </svg>
  );
};
